import { Injectable } from '@angular/core';
import { SiteIntelligenceLayer } from '../../models/site-intelligence-layer';

interface IntelligenceData {
  markedPointAddress: string | null;
  locationDetails: SiteIntelligenceLayer[] | null;
  expandedCards: boolean[];
}

@Injectable({
  providedIn: 'root',
})
export class SiteIntelligenceService {
  private data: IntelligenceData = {
    markedPointAddress: null,
    locationDetails: null,
    expandedCards: [],
  };

  getCurrentData(): IntelligenceData {
    return this.data;
  }

  setMarkedPointAddress(address: string | null) {
    this.data.markedPointAddress = address;
  }

  setLocationDetails(details: SiteIntelligenceLayer[] | null) {
    this.data.locationDetails = details;
  }

  setExpandedCards(cards: boolean[]) {
    this.data.expandedCards = cards;
  }

  clearData() {
    this.data = {
      markedPointAddress: null,
      locationDetails: null,
      expandedCards: [],
    };
  }
}
